import React from "react";
import { useFocusEffect } from "@react-navigation/native";
import { ScreenNameList } from "@lib/utilities/Constants";
import { useAppDispatch, useAppSelector } from "@lib";
import { messages } from "../../../src/resources/strings";
import { setError } from "@lib";
import { setCurrentPolicyNumber } from "@lib";
import { getPolicyNumber } from "@lib/utilities/Helpers";

export const useMakeClaim = () => {
  // redux
  const dispatch = useAppDispatch();
  const policyData = useAppSelector((state) => state?.policyReducer);
  const selectedPolicy = useAppSelector(
    (state) => state.policyReducer.policyNumber
  );
  const { agent, loading, error, policyNumber } = useAppSelector(
    (state) => state.policyDetailReducer
  );

  // error constants
  const errorData = {
    message: error,
    screenName: ScreenNameList.makeClaim,
  };

  const onReloadPress = async () => {
    const policyNumber = await getPolicyNumber();
    const policy = policyData.policies.find(
      (item: any) => item.policyNumber === policyNumber
    );
    if (policy) {
      dispatch(setCurrentPolicyNumber(policy.policyNumber));
      dispatch(setError(messages.error.noError));
    }
  };

  return {
    policyNumber,
    policyList: policyData.policies,
    agent,
    loading,
    error,
    selectedPolicy,
    onReloadPress,
    errorData,
    onEndTimer: () => {
      dispatch(setError(messages.error.noError));
    },
  };
};
